// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"jT-z","smallCardRow":"kT-z","largeCardRow":"lT-z","productSearchRow":"mT-z","curatedRow":"nT-z"};